import { render, staticRenderFns } from "./PriceTariffForm.vue?vue&type=template&id=01528d1a"
import script from "./PriceTariffForm.vue?vue&type=script&lang=js"
export * from "./PriceTariffForm.vue?vue&type=script&lang=js"
import style0 from "./PriceTariffForm.vue?vue&type=style&index=0&id=01528d1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports